(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["paris-editorial-strip"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('paris-editorial-strip')) {
  customElements.define('paris-editorial-strip', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const button = this.querySelector('.paris-strip__pause');
      button.addEventListener('click', () => {
        const paused = this.toggleAttribute('data-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? button.dataset.resume : button.dataset.pause);
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
